/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { IDiagLabPanel } from 'app/shared/model/diag-lab-panel.model';
import { ILabTestItem } from 'app/shared/model/lab-test-item.model';
import { IImageTests } from 'app/shared/model/image-tests.model';

export interface IDiaglabTestThreshold {
  id?: string;
  sourceStatusCode?: string | null;
  targetStatusCode?: string;
  threshold?: number;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  diagLab?: IDiagLab | null;
  panel?: IDiagLabPanel | null;
  testItem?: ILabTestItem | null;
  radiologyTest?: IImageTests | null;
}

export const defaultValue: Readonly<IDiaglabTestThreshold> = {
  active: false,
};
